import React from 'react'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import ListItemText from '@material-ui/core/ListItemText'
import Typography from '@material-ui/core/Typography'
import makeStyles from '@material-ui/core/styles/makeStyles'
import MapMarkerSvg from 'images/icons/fc-marketing/map-marker.svg'
import PhoneSvg from 'images/icons/fc-marketing/phone.svg'
import { LocationCard } from 'components/program-marketing/location-card'
import { urls } from 'pages/junior-league-marketing/layout/menus'

const Icon = ({ svg, alt }) => <img src={svg} alt={alt} />

const useStyles = makeStyles(theme => ({
  locationListItemIcon: {
    marginTop: '6px',
  },
  locationListItem: {
    padding: '0 40px 8px 0',
    alignItems: 'flex-start',
  },
  addressList: {
    paddingTop: theme.spacing(3),
    height: '100%',
  },
}))

const LocationListItem = ({ icon, children }) => {
  const classes = useStyles()
  return (
    <ListItem className={classes.locationListItem}>
      <ListItemIcon className={classes.locationListItemIcon}>
        {icon}
      </ListItemIcon>
      <ListItemText
        primary={<Typography variant="body2">{children}</Typography>}
      />
    </ListItem>
  )
}

const Text = ({ children }) => (
  <Typography component="span" style={{ display: 'block' }}>
    {children}
  </Typography>
)

export const Location = ({ location }) => {
  const { facility } = location
  const classes = useStyles()
  const searchUrl = `${urls.search}?${new URLSearchParams({
    label: facility.name,
    lat: facility.latitude,
    lng: facility.longitude,
    type: 'facility',
  })}`

  return (
    <LocationCard
      title="Location"
      subtitle={facility.name}
      buttonText={`More Events by ${location.name}`}
      url={searchUrl}
    >
      <List className={classes.addressList}>
        <LocationListItem icon={<Icon svg={MapMarkerSvg} alt="map-marker" />}>
          <Text>{facility.address1} </Text>
          <Text>{facility.address2}</Text>
          <Text>
            {facility.city}, {facility.state} {facility.zip}
          </Text>
        </LocationListItem>

        {facility.phone && (
          <LocationListItem icon={<Icon svg={PhoneSvg} alt="phone" />}>
            <Text>{facility.phone}</Text>
          </LocationListItem>
        )}
      </List>
    </LocationCard>
  )
}
